import { RacemapColors } from '@racemap/utilities/consts/common';
import type { CSSProperties } from 'react';
import { useNavigate } from 'react-router-dom';
import { IconChartLine } from 'src/components/BasicComponents/Icons';

export function PredictionStarterAnalyseLink({
  eventId,
  starterId,
}: {
  eventId: string;
  starterId: string;
}) {
  const navigate = useNavigate();

  const style: CSSProperties = {
    cursor: 'pointer',
    marginLeft: '5px',
  };

  const handleClick = () => {
    navigate(`/admin/events/${eventId}/prediction/analyse?starterId=${starterId}`);
  };

  return (
    <div
      title="Click to analyse and show details for this Starter."
      style={style}
      onClick={handleClick}
      onKeyUp={(e) => e.key === 'Enter' && handleClick}
    >
      <IconChartLine color={RacemapColors.PaleBlue} />
    </div>
  );
}
